
  <div class="modal-body warning_bdy awswarning">
    <p>Due to an issue with the underlying Amazon Web Services infrastructure, Wiley Digital Archives is unavailable at this time. Please try again later. Our apologies for the inconvenience caused and we are working hard to resolve the issue.</p>
  </div>